
    import { defineComponent } from 'vue'
    import { filterDefault } from '@/helpers/commons/filterHelper'
    import Card from 'primevue/card'
    import Column from 'primevue/column'
    import DataTable from 'primevue/datatable'
    import glossaryUsageNavigationCardDescriptor from './GlossaryUsageNavigationCardDescriptor.json'

    export default defineComponent({
        name: 'glossary-usage-navigation-card',
        components: { Card, Column, DataTable },
        props: {
            items: { type: Object },
            type: { type: String },
            glossaryChanged: { type: Boolean }
        },
        emits: ['infoClicked', 'linkClicked', 'selected'],
        data() {
            return {
                glossaryUsageNavigationCardDescriptor,
                filters: { global: [filterDefault] } as Object,
                selectedItems: [],
                user: {} as any
            }
        },
        watch: {
            glossaryChanged() {
                this.selectedItems = []
            }
        },
        computed: {
            title(): string {
                switch (this.type) {
                    case 'document':
                        return this.$t('managers.glossary.glossaryUsage.documents')
                    case 'dataset':
                        return this.$t('managers.glossary.glossaryUsage.dataset')
                    case 'businessClass':
                        return this.$t('managers.glossary.glossaryUsage.businessClass')
                    case 'table':
                        return this.$t('managers.glossary.glossaryUsage.tables')
                    default:
                        return ''
                }
            },
            canSeeLinkTable(): boolean {
                let index = -1
                if (this.user.functionalities) {
                    index = this.user.functionalities.findIndex((el: string) => el === 'ManageGlossaryTechnical')
                }
                return index !== -1
            }
        },
        created() {
            this.user = (this.$store.state as any).user
        },
        methods: {
            onItemsSelected() {
                this.$emit('selected', this.selectedItems)
            }
        }
    })
